// Colour pipeline shared by the live CSS preview and the server-side export (same ops, same order).
export const COLOR_PRESETS = [
  { id: "original", chain: [] },
  { id: "sepia", chain: [{ fn: "sepia", v: 1 }] },
  { id: "bw", chain: [{ fn: "grayscale", v: 1 }] },
  { id: "glace", chain: [{ fn: "tint", v: [0.86, 0.97, 1.14] }, { fn: "saturate", v: 0.85 }, { fn: "contrast", v: 1.05 }, { fn: "brightness", v: 1.04 }] },
  { id: "cinema", chain: [{ fn: "contrast", v: 1.2 }, { fn: "saturate", v: 1.2 }, { fn: "tint", v: [1.07, 1.0, 0.9] }] },
  { id: "vintage", chain: [{ fn: "sepia", v: 0.45 }, { fn: "contrast", v: 0.9 }, { fn: "brightness", v: 1.06 }, { fn: "saturate", v: 0.85 }] },
  { id: "neon", chain: [{ fn: "saturate", v: 1.9 }, { fn: "contrast", v: 1.25 }, { fn: "brightness", v: 1.05 }, { fn: "tint", v: [1.05, 0.92, 1.12] }] },
];

export const NEUTRAL = { preset: "original", brightness: 100, contrast: 100, saturate: 100, sepia: false, bw: false };

export const buildChain = (s) => {
  const preset = COLOR_PRESETS.find((p) => p.id === s.preset) || COLOR_PRESETS[0];
  const chain = [...preset.chain];
  if (s.brightness !== 100) chain.push({ fn: "brightness", v: s.brightness / 100 });
  if (s.contrast !== 100) chain.push({ fn: "contrast", v: s.contrast / 100 });
  if (s.saturate !== 100) chain.push({ fn: "saturate", v: s.saturate / 100 });
  if (s.sepia) chain.push({ fn: "sepia", v: 1 });
  if (s.bw) chain.push({ fn: "grayscale", v: 1 });
  return chain;
};

export const tintId = (v) => `frz-tint-${v.map((x) => Math.round(x * 100)).join("-")}`;

export const chainToCss = (chain) =>
  chain.length
    ? chain.map(({ fn, v }) => (fn === "tint" ? `url(#${tintId(v)})` : fn === "hue-rotate" ? `hue-rotate(${v}deg)` : `${fn}(${v})`)).join(" ")
    : "none";

const ALL_TINTS = COLOR_PRESETS.flatMap((p) => p.chain.filter((c) => c.fn === "tint").map((c) => c.v));

export const TintDefs = () => (
  <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
    <defs>
      {ALL_TINTS.map((v) => (
        <filter key={tintId(v)} id={tintId(v)} colorInterpolationFilters="sRGB">
          <feColorMatrix type="matrix" values={`${v[0]} 0 0 0 0  0 ${v[1]} 0 0 0  0 0 ${v[2]} 0 0  0 0 0 1 0`} />
        </filter>
      ))}
    </defs>
  </svg>
);
